export const getCustomAttribute = (data, attributeType, subType, customAttributesKey, attributeKeys) => {
    let res = null;
    let resIndex = null;
    
    if (data?.hasOwnProperty(customAttributesKey)) {
        for (let i = 0; i < data[customAttributesKey]?.length; i++) {
            let attribute = data[customAttributesKey][i];
            if (attribute[attributeKeys.attribute_type] === attributeType && 
                attribute[attributeKeys.sub_type] === subType) {
                res = attribute[attributeKeys.attribute];
                resIndex = i;
                break;
            }
        }
    }
    
    return [res, resIndex];
};

export const updateCustomAttribute = (data, attributeType, value, subType, customAttributesKey, attributeKeys) => {
    const [, index] = getCustomAttribute(data, attributeType, subType, customAttributesKey, attributeKeys);
    
    const obj = {
        [attributeKeys.attribute_type]: attributeType,
        [attributeKeys.attribute]: value.toString(),
        [attributeKeys.sub_type]: subType
    };
    
    if (index !== null) {
        data[customAttributesKey][index] = obj;
    } else {
        if (!data.hasOwnProperty(customAttributesKey) || !data[customAttributesKey]) {
            data[customAttributesKey] = [obj];
        } else {
            data[customAttributesKey].push(obj);
        }
    }
};

export const getCustomAttributeValue = (data, attributeType, subType, customAttributesKey, attributeKeys) => {
    const [val] = getCustomAttribute(data, attributeType, subType, customAttributesKey, attributeKeys);
    
    // Handle boolean conversion for specific fields
    if (attributeType === 'BACKUP_WORKDOCS_LOCATION_ENABLED' || 
        attributeType === 'UPLOAD_ONLY_TO_ALIASES' || 
        attributeType === 'QUEUED_EXECUTION') {
        return val === 'true';
    }
    
    return val;
};